class WithdrawModel {
  private _id: any;
  private _app_id: any;
  private _name: any;
  private _year: any;
  private _programme: any;
  private _email: any;
  private _contact: any;
  private _rollNo: any;
  private _dob: any;
  private _address: any;
  private _reason: any;
  private _reason_desc: any;
  private _bank_acc_no: any;
  private _bank_acc_name: any;
  private _bank_address: any;
  private _bank_ifsc: any;
  private _confirm: any;
  private _withdrawal_letter_doc_id: any;
  private _status: any;
  private _g_creation_time: any;
  constructor(data: any) {
    this._id = data["id"];
    this._app_id = data["app_id"];
    this._name = data["name"];
    this._year = data["year"];
    this._programme = data["programme"];
    this._email = data["email"];
    this._contact = data["contact"];
    this._rollNo = data["rollNo"];
    this._dob = data["dob"];
    this._address = data["address"];
    this._reason = data["reason"];
    this._reason_desc = data["reason_desc"];
    this._bank_acc_no = data["bank_acc_no"];
    this._bank_acc_name = data["bank_acc_name"];
    this._bank_address = data["bank_address"];
    this._bank_ifsc = data["bank_ifsc"];
    this._confirm = data["confirm"];
    this._withdrawal_letter_doc_id = data["withdrawal_letter_doc_id"];
    this._status = data["status"];
    this._g_creation_time = data["g_creation_time"];
  }

  public getId(): any {
    return this._id;
  }

  public setId(value: any) {
    this._id = value;
  }

  public getApp_id(): any {
    return this._app_id;
  }

  public setApp_id(value: any) {
    this._app_id = value;
  }

  public getName(): any {
    return this._name;
  }

  public setName(value: any) {
    this._name = value;
  }

  public getYear(): any {
    return this._year;
  }

  public setYear(value: any) {
    this._year = value;
  }

  public getProgramme(): any {
    return this._programme;
  }

  public setProgramme(value: any) {
    this._programme = value;
  }

  public getEmail(): any {
    return this._email;
  }

  public setEmail(value: any) {
    this._email = value;
  }

  public getContact(): any {
    return this._contact;
  }

  public setContact(value: any) {
    this._contact = value;
  }

  public getRollNo(): any {
    return this._rollNo;
  }

  public setRollNo(value: any) {
    this._rollNo = value;
  }

  public getDob(): any {
    return this._dob;
  }

  public setDob(value: any) {
    this._dob = value;
  }

  public getAddress(): any {
    return this._address;
  }

  public setAddress(value: any) {
    this._address = value;
  }

  public getReason(): any {
    return this._reason;
  }

  public setReason(value: any) {
    this._reason = value;
  }

  public getReason_desc(): any {
    return this._reason_desc;
  }

  public setReason_desc(value: any) {
    this._reason_desc = value;
  }

  public getBank_acc_no(): any {
    return this._bank_acc_no;
  }

  public setBank_acc_no(value: any) {
    this._bank_acc_no = value;
  }

  public getBank_acc_name(): any {
    return this._bank_acc_name;
  }

  public setBank_acc_name(value: any) {
    this._bank_acc_name = value;
  }

  public getBank_address(): any {
    return this._bank_address;
  }

  public setBank_address(value: any) {
    this._bank_address = value;
  }

  public getBank_ifsc(): any {
    return this._bank_ifsc;
  }

  public setBank_ifsc(value: any) {
    this._bank_ifsc = value;
  }

  public getConfirm(): any {
    return this._confirm;
  }

  public setConfirm(value: any) {
    this._confirm = value;
  }

  public getWithdrawal_letter_doc_id(): any {
    return this._withdrawal_letter_doc_id;
  }

  public setWithdrawal_letter_doc_id(value: any) {
    this._withdrawal_letter_doc_id = value;
  }

  public getStatus(): any {
    return this._status;
  }

  public setStatus(value: any) {
    this._status = value;
  }

  public getG_creation_time(): any {
    return this._g_creation_time;
  }

  public setG_creation_time(value: any) {
    this._g_creation_time = value;
  }

  public toJson(): any {
    return {
      id: this._id,
      app_id: this._app_id,
      name: this._name,
      year: this._year,
      programme: this._programme,
      email: this._email,
      contact: this._contact,
      rollNo: this._rollNo,
      dob: this._dob,
      address: this._address,
      reason: this._reason,
      reason_desc: this._reason_desc,
      bank_acc_no: this._bank_acc_no,
      bank_acc_name: this._bank_acc_name,
      bank_address: this._bank_address,
      bank_ifsc: this._bank_ifsc,
      confirm: this._confirm,
      withdrawal_letter_doc_id: this._withdrawal_letter_doc_id,
      status: this._status,
      g_creation_time: this._g_creation_time,
    };
  }

  public static fromJson(json: any): WithdrawModel {
    return new WithdrawModel(json);
  }
}

export default WithdrawModel;